import { gql } from '@apollo/client';

export default gql`
  mutation updateSalesforceBookingStatus($bookingReference: String!, $status: BookingStatus!) {
    updateSalesforceBookingStatus(bookingReference: $bookingReference, status: $status)
  }
`;
